import { IStock } from '@notino/shared/definitions/custom-definitions';
import { VariantFragmentFragment } from '@notino/shared/definitions/types';

import { getRenderableAttributes } from '@components/Tags/utils';

const hasTagOrDiscount = (variant: VariantFragmentFragment): boolean => {
  const attributes = getRenderableAttributes(variant.attributes);
  const hasAttributes = Object.keys(attributes).length > 0;
  const hasDiscount =
    variant.stockAvailability.code !== IStock.outOfStock &&
    Boolean(variant.originalPrice) &&
    variant.originalPrice.value > 0;
  return hasAttributes || hasDiscount;
};

export const shouldRenderTagDiscount = (
  variants: VariantFragmentFragment[]
): boolean => variants.some(hasTagOrDiscount);
